import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select } from "./UI";

export function useMeta() {
  const [meta, setMeta] = useState({ regions: [], countries: [], statuses: [] });
  const [dcs, setDcs] = useState([]);
  useEffect(() => {
    api.get("/meta").then((r) => setMeta(r.data)).catch(() => {});
    api.get("/distribution-centers").then((r) => setDcs(r.data)).catch(() => {});
  }, []);
  return { meta, dcs };
}

export const RegionFilters = ({ value, onChange, showDc = true, showCountry = true, extra }) => {
  const { meta, dcs } = useMeta();
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  return (
    <div className="mb-6 flex flex-wrap items-end gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" data-testid="region-filters">
      <Select label="Region" testId="filter-region" value={value.region || "all"} onChange={set("region")}
        options={[{ value: "all", label: "All Regions" }, ...meta.regions.map((r) => ({ value: r, label: r }))]} />
      {showCountry && <Select label="Store Country" testId="filter-country" value={value.country || "all"} onChange={set("country")}
        options={[{ value: "all", label: "All Countries" }, ...meta.countries.map((c) => ({ value: c, label: c }))]} />}
      {showDc && <Select label="Distribution Center" testId="filter-dc" value={value.dc_id || "all"} onChange={set("dc_id")}
        options={[{ value: "all", label: "All DCs" }, ...dcs.map((d) => ({ value: d.id, label: d.name }))]} />}
      {extra}
    </div>
  );
};
